var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cropRecord"}},[_vm._v(" 裁剪录入 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }